// src/features/executive/insight/hooks/use-new-vs-existing.ts
import { useExecutiveQuery } from 'features/executive/shared/hooks/use-executive-query'
import InsightApi from 'api/executive/insight.api'
import type {
  GetInsightNewVsExistingParams,
  InsightNewVsExistingResponse,
} from 'api/executive/executive.types'

export function useNewVsExisting() {
  return useExecutiveQuery<GetInsightNewVsExistingParams, InsightNewVsExistingResponse>(
    'insight.new-vs-existing',
    InsightApi.getNewVsExisting,
    (f) => {
      if (!f.dateRange?.start || !f.dateRange?.end) return null
      return {
        dateFrom: f.dateRange.start,
        dateTo: f.dateRange.end,
        branchId: f.branchId ?? undefined,
        doctorId: f.doctorId ?? undefined,
        // patientType self-collapse — forward anyway; mock ignores it.
        patientType: f.patientType ?? undefined,
        nationality: f.nationality ?? undefined,
        sourceChannel: f.sourceChannel ?? undefined,
        promotionId: f.promotionId ?? undefined,
      }
    }
  )
}
